
<template>
<div class="card largura m-5" id="autoconsumo">
    <img class="card-img-top pt-2" src="../assets/images/gestao-tempo.jpg" alt="Baixe E-book Gratuito">
    <div class="card-body">
        <h5 class="card-title font-weight-bold">
            Faça o download gratuito do e-book: Como Gerenciar seu Tempo
        </h5>
        <p class="card-text">Você já teve a sensação que o dia escapou entre seus dedos? Gerencie seu tempo e potencialize sua produtividade com nosso e-book. Conquiste o controle do seu dia e alcance o sucesso que você merece!</p>
        <a href="https://inscricao.sebraesp.com.br/Conclusao/DownloadProduto/4457" class="btn btn-primary" id="Download" @click="donwload" :class="{ 'disabled': !linkHabilitado }" >Baixar E-book Gratuito</a>
    </div>
</div>
</template>
<style>
    .largura {
        max-width:450px !important;
    }
    .disabled {
    pointer-events: none;
    opacity: 0.5;
    }
</style>
<script>
export default {
  name: "AutoConsumo",
  data() {
    return {
      linkHabilitado: true
    };
  },
  methods: {
    donwload() {
      this.$root.$emit('acionarModal', 'O download será iniciado em instantes! Verifique a pasta de donwloads do seu dispositivo.');
      this.linkHabilitado = false;
    },
  },
};
</script>